import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import './Legal.css';

const MentionsLegales = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-content">
          <img 
            src="https://customer-assets.emergentagent.com/job_pro-service-hub-5/artifacts/w0r3tvio_APP%20ICON.png" 
            alt="ZotPro Logo" 
            className="legal-logo"
          />
          <Button onClick={() => navigate('/')} className="back-btn">
            <ArrowLeft size={20} />
            Retour à l'accueil
          </Button>
        </div>
      </header>

      <div className="legal-container">
        <h1 className="legal-title">Mentions Légales</h1>
        <p className="legal-date">Dernière mise à jour : Décembre 2025</p>

        <section className="legal-section">
          <h2>1. Éditeur du site</h2>
          <p>Le site ZotPro est édité par :</p>
          <ul>
            <li><strong>Raison sociale :</strong> SARL DEALRUN</li>
            <li><strong>Forme juridique :</strong> Société à Responsabilité Limitée (SARL)</li>
            <li><strong>SIRET :</strong> 89535078300018</li>
            <li><strong>Siège social :</strong> 33 Boulevard du Mahatma Gandhi, Sainte Clotilde, 97490 Saint-Denis, La Réunion</li>
            <li><strong>Téléphone :</strong> 0693463628</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>2. Directeur de la publication</h2>
          <p>Le directeur de la publication du site est le représentant légal de la société DEALRUN.</p>
        </section>

        <section className="legal-section">
          <h2>3. Hébergement</h2>
          <p>Le site ZotPro est hébergé par :</p>
          <ul>
            <li><strong>Hébergeur :</strong> Emergent</li>
            <li><strong>Adresse :</strong> Services d'hébergement cloud</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Propriété intellectuelle</h2>
          <p>
            L'ensemble du contenu du site ZotPro (textes, images, vidéos, logos, graphismes, etc.) 
            est la propriété exclusive de DEALRUN ou de ses partenaires. Toute reproduction, 
            représentation, modification, publication ou adaptation de tout ou partie des éléments 
            du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation 
            écrite préalable de DEALRUN.
          </p>
          <p>
            Le nom "ZotPro" et le logo associé sont des marques déposées ou en cours de dépôt. 
            Toute utilisation non autorisée de ces marques est prohibée et constituerait une 
            contrefaçon sanctionnée par les articles L. 335-2 et suivants du Code de la 
            propriété intellectuelle.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Protection des données personnelles</h2>
          <p>
            Conformément à la loi n° 78-17 du 6 janvier 1978 relative à l'informatique, 
            aux fichiers et aux libertés, modifiée par la loi n° 2004-801 du 6 août 2004, 
            et au Règlement Général sur la Protection des Données (RGPD) du 27 avril 2016, 
            vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition 
            aux données personnelles vous concernant.
          </p>
          <p>
            Pour exercer ces droits, vous pouvez nous contacter à l'adresse suivante : 
            <strong> 0693463628</strong>
          </p>
          <p>
            Pour plus d'informations sur la collecte et le traitement de vos données personnelles, 
            veuillez consulter notre <a href="/politique-confidentialite">Politique de Confidentialité</a>.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Cookies</h2>
          <p>
            Le site ZotPro utilise des cookies pour améliorer l'expérience utilisateur et 
            réaliser des statistiques de visite. En continuant à naviguer sur ce site, vous 
            acceptez l'utilisation de cookies conformément à notre politique de confidentialité.
          </p>
          <p>
            Vous pouvez désactiver les cookies dans les paramètres de votre navigateur, 
            mais certaines fonctionnalités du site pourraient ne plus être accessibles.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Responsabilité</h2>
          <p>
            DEALRUN s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées 
            sur le site ZotPro. Toutefois, DEALRUN ne peut garantir l'exactitude, la précision ou 
            l'exhaustivité des informations mises à disposition sur ce site.
          </p>
          <p>
            En conséquence, DEALRUN décline toute responsabilité pour toute imprécision, 
            inexactitude ou omission portant sur des informations disponibles sur le site.
          </p>
          <p>
            DEALRUN ne pourra être tenu responsable des dommages directs ou indirects résultant 
            de l'accès au site ou de l'utilisation du site, y compris l'inaccessibilité, les 
            pertes de données, détériorations, destructions ou virus qui pourraient affecter 
            l'équipement informatique de l'utilisateur.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Liens hypertextes</h2>
          <p>
            Le site ZotPro peut contenir des liens hypertextes vers d'autres sites. DEALRUN 
            n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à 
            leur contenu, leurs pratiques ou leurs politiques de confidentialité.
          </p>
          <p>
            La création de liens hypertextes vers le site ZotPro nécessite l'autorisation 
            préalable et écrite de DEALRUN.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Droit applicable et juridiction compétente</h2>
          <p>
            Les présentes mentions légales sont régies par le droit français. En cas de litige 
            relatif à l'interprétation ou à l'exécution des présentes, et à défaut de règlement 
            amiable, les tribunaux français seront seuls compétents.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Contact</h2>
          <p>
            Pour toute question concernant les présentes mentions légales, vous pouvez nous contacter :
          </p>
          <ul>
            <li><strong>Par téléphone :</strong> 0693463628</li>
            <li><strong>Par courrier :</strong> SARL DEALRUN, 33 Boulevard du Mahatma Gandhi, Sainte Clotilde, 97490 Saint-Denis, La Réunion</li>
          </ul>
        </section>
      </div>

      <footer className="legal-footer">
        <p>© 2025 ZotPro - SARL DEALRUN. Tous droits réservés.</p>
      </footer>
    </div>
  );
};

export default MentionsLegales;
